import { gql, useMutation } from '@apollo/client';

const DELETE_AUDIT_POLICY_SNIPPET = gql`
  mutation DeleteAuditPolicySnippet($description: String!) {
    deleteAuditPolicySnippet(description: $description)
  }
`;

export interface DeleteAuditPolicySnippetVariables {
  description: string;
}

export interface DeleteAuditPolicySnippetData {
  deleteAuditPolicySnippet: boolean;
}

export function useDeleteAuditPolicySnippetMutation() {
  return useMutation<DeleteAuditPolicySnippetData, DeleteAuditPolicySnippetVariables>(DELETE_AUDIT_POLICY_SNIPPET);
}
